<template>
  <div>
    <a class="attachLink" @click="download(item)">
      <i :class="mimeTypeToFontAwesome(item.contentType)"></i>
      {{ item.name }}
    </a>
    <a :id="item.id + 'down'" :download="item.name" style="display:none;"></a>
    <span class="attach-creator ml-2">
      {{ user(item.creator.id).username }}
    </span>
    <span class="attach-created ml-2">
      {{ item.createdAt * 1000 | moment('DD.MM.YYYY HH:mm') }}
    </span>
  </div>
</template>

<script>
// TODO cele tohle predelat.... broken this shit is!

export default {
    props: ['item'],
    methods: {
        download(attachment) {
            const data = 'data:' + attachment.contentType + ';base64,' + attachment.data
            const dlnk = document.getElementById(attachment.id + 'down')
            dlnk.href = data
            dlnk.download = attachment.name
            dlnk.click()
        },
        user(id) {
            return this.$store.getters.userById(id)
        },
        mimeTypeToFontAwesome(mimeType) {
            const iconClasses = {
                'image': 'far fa-image',
                'audio': 'far fa-file-audio',
                'video': 'far fa-file-video',
                // Documents
                'application/pdf': 'far fa-file-pdf',
                'application/msword': 'far fa-file-word',
                'application/vnd.ms-word': 'far fa-file-word',
                'application/vnd.oasis.opendocument.text': 'far fa-file-word',
                'application/vnd.openxmlformats-officedocument.wordprocessingml': 'far fa-file-word',
                'application/vnd.ms-excel': 'far fa-file-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml': 'far fa-file-excel',
                'application/vnd.oasis.opendocument.spreadsheet': 'far fa-file-excel',
                'application/vnd.ms-powerpoint': 'far fa-file-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml': 'far fa-file-powerpoint',
                'application/vnd.oasis.opendocument.presentation': 'far fa-file-powerpoint',
                'text/plain': 'far fa-file-alt',
                'text/html': 'far fa-file-code',
                'application/json': 'far fa-file-code',
                // Archives
                'application/gzip': 'far fa-file-archive',
                'application/zip': 'far fa-file-archive',
            }
            let result = 'far fa-file'
            _.forEach(iconClasses, (value, key) => {
                if (mimeType.indexOf(key) === 0) {
                    result = value
                }
            })
            return result
        },
    },
}
</script>
<style lang="scss" scoped>
  .attachLink {
    font-weight: bold;
    color: #3F729B !important;
    cursor: pointer;
    &:hover {
      color:#1C2331 !important;
    }
  }
  .attach-creator{
    color: #5f5f5f;
  }
  .attach-created{
    color: #5f5f5f;
  }
</style>
